<script>
    import { currency_formatter } from "../../globals";
    import Header from "../header.svelte"
    import IFTAInput from "../../utils/iftainput.svelte";
    import { all_jobs_store, expenses_store } from "../../stores.js";
    import { init_data } from "../../init.js";
    import { onMount } from "svelte";
    import { formatDate } from "../../utils/format.js";


    let is_busy = false;
    let content_title = "Accounting - P&L";
    let daterange = undefined;
    let all_jobs = [];
    let all_expenses = [];
    let from_date = null;
    let to_date = null;
    let revenue = 0;
    let cost_of_revenues = { 'Labor': 0 };
    let sum_cost_of_revenues = 0;
    let other_expenses = {};
    let sum_other_expenses = 0;
    let gross_profit = 0;
    let net_profit = 0;

    $: {
        if (daterange) {
            from_date = daterange.split(' to ')[0];
            to_date = daterange.split(' to ')[1];
            get_revenue();
            get_expense_info();
        }
    }

    onMount(() => {
        init_data('expenses');
    });

    const get_revenue = () => {
        revenue = 0;
        for (let i = 0; i < all_jobs.length; i ++) {
            const job = all_jobs[i];
            let is_able = false;
            if (job.status === 'charged') {
                if (from_date && job.approved_at) {
                    if (to_date) {
                        if (formatDate(from_date) <= formatDate(job.approved_at) && formatDate(job.approved_at) <= formatDate(to_date)) {
                            is_able = true;
                        }
                    } else {
                        if (formatDate(from_date) == formatDate(job.approved_at)) {
                            is_able = true;
                        }
                    }
                } else {
                    is_able = true;
                }
            }
            if (is_able) revenue += job.total_service_price;
        }
        gross_profit = revenue - sum_cost_of_revenues;
        net_profit = gross_profit - sum_other_expenses;
    }
    const get_expense_info = () => {
        cost_of_revenues = {};
        other_expenses = {};
        sum_cost_of_revenues = 0;
        sum_other_expenses = 0;
        for (let i = 0; i < all_expenses.length; i ++) {
            const expense = all_expenses[i];
            let is_able = false;
            if (from_date) {
                if (to_date) {
                    if (formatDate(from_date) <= formatDate(expense.bill_date) && formatDate(expense.bill_date) <= formatDate(to_date)) {
                        is_able = true;
                    }
                } else {
                    if (formatDate(from_date) === formatDate(expense.bill_date)) {
                        is_able = true;
                    }
                }
            } else { is_able = true; }

            if (is_able) {
                if (expense.category_type === 'Cost of Revenue') {
                    if (expense.expense_category in cost_of_revenues) {
                        cost_of_revenues[expense.expense_category] += expense.amount;
                    } else {
                        cost_of_revenues[expense.expense_category] = expense.amount;
                    }
                    sum_cost_of_revenues += expense.amount;
                } else {
                    if (expense.expense_category in other_expenses) {
                        other_expenses[expense.expense_category] += expense.amount;
                    } else {
                        other_expenses[expense.expense_category] = expense.amount;
                    }
                    sum_other_expenses += expense.amount;
                }
            }
        }
        gross_profit = revenue - sum_cost_of_revenues;
        net_profit = gross_profit - sum_other_expenses;
    }

    all_jobs_store.subscribe(value => {
        all_jobs = value;
        get_revenue();
    });
    expenses_store.subscribe(value => {
        all_expenses = value;
        get_expense_info();
    });
</script>


<Header title="{content_title}" bind:is_busy={is_busy} />

<div class="contentholder">
    <div class="exportbuttonbar">
        <button class="exportbutton" on:click={() => {
            let body = [];
            body.push(`Revenue,$${revenue.toFixed(2)}`);
            for (let i = 0; i < Object.keys(cost_of_revenues).length; i ++) {
                const cost_of_revenue_key = Object.keys(cost_of_revenues)[i];
                body.push(`${cost_of_revenue_key},$${cost_of_revenues[cost_of_revenue_key].toFixed(2)}`);
            }
            body.push(`Cost of Revenue,$${sum_cost_of_revenues.toFixed(2)}`);
            body.push(`GROSS PROFIT,$${gross_profit.toFixed(2)}`);
            body.push(',');
            body.push(`OTHER EXPENSES,`);
            for (let i = 0; i < Object.keys(other_expenses).length; i ++) {
                const other_expense_key = Object.keys(other_expenses)[i];
                body.push(`${other_expense_key},$${other_expenses[other_expense_key].toFixed(2)}`);
            }
            body.push(`TOTAL,$${sum_other_expenses.toFixed(2)}`);
            body.push(',');
            body.push(`NET PROFIT,$${net_profit.toFixed(2)}`);
            const csv_file = body.join('\n');
            var blob = new Blob([csv_file]);
            var link = document.createElement('a');
            link.href = window.URL.createObjectURL(blob);
            link.download = 'profit_and_loss.csv';
            link.click();
        }} ><i class="fas fa-file-export"></i> Export CSV</button>
    </div>
 
    <div class="section">
        <div class="righttoolsholder">
            <IFTAInput
                type="daterange"
                label="Date Range"
                placeholder=""
                bind:value={daterange}
            />
        </div>

        <div>
            <div class="pl_item_parent" style="margin-bottom: 12px;">
                <span>Revenue</span>
                <span>{currency_formatter.format(revenue)}</span>
            </div>
            {#each Object.keys(cost_of_revenues) as cost_of_revenue_key}
                <div class="pt_item_child">
                    <span>{cost_of_revenue_key}</span>
                    <span>{currency_formatter.format(cost_of_revenues[cost_of_revenue_key])}</span>
                </div>
            {/each}


            <div class="pl_item_spliter">
                <div class="pl_item_spliter_line"></div>
            </div>

            <div class="pl_item_parent">
                <span>Cost of Revenue</span>
                <span>{currency_formatter.format(sum_cost_of_revenues)}</span>
            </div>
            <br />

            <div class="pl_item_parent">
                <span><b>GROSS PROFIT</b></span>
                <span><b>{currency_formatter.format(gross_profit)}</b></span>
            </div>
            <br />

            <div class="pl_item_parent">
                <span>OTHER EXPENSES</span>
            </div>
            {#each Object.keys(other_expenses) as other_expense_key}
                <div class="pt_item_child">
                    <span>{other_expense_key}</span>
                    <span>{currency_formatter.format(other_expenses[other_expense_key])}</span>
                </div>
            {/each}
            <div class="pl_item_spliter">
                <div class="pl_item_spliter_line"></div>
            </div>
            <div class="pt_item_child">
                <span>TOTAL</span>
                <span>{currency_formatter.format(sum_other_expenses)}</span>
            </div>
            <br />

            <div class="pl_item_spliter">
                <div class="pl_item_spliter_line"></div>
            </div>
            <div class="pl_item_parent">
                <span><b>NET PROFIT</b></span>
                <span><b>{currency_formatter.format(net_profit)}</b></span>
            </div>

            <div class="pl_item_spliter">
                <div class="pl_item_spliter_line"></div>
            </div>
            <div class="pl_item_spliter">
                <div class="pl_item_spliter_line"></div>
            </div>
            <br />
        </div>
    </div>
</div>


<style>
    .contentholder {
        width: 100%;
    }
    .exportbuttonbar {
        margin-top: 10px;
        width: 100%;
        display: flex;
        flex-direction: row-reverse;
        justify-content: space-between;
    }
    .exportbuttonbar button {
        max-width: 300px;
        width: 100%;
        background-color: #ff9100;
        color: white;
    }
    :global(.toolsholder .group) {
        padding-left: 10px;
        padding-right: 10px;
    }
    .righttoolsholder {
        width: 500px;
        display: flex;
        flex-direction: row;
        justify-content: end;
        box-sizing: border-box;     
    }
    :global(.righttoolsholder .group) {
        margin-left: 25px;
    }
    .pl_item_parent {
        padding-left: 25px;
        padding-right: 25px;
        display: flex;
        justify-content: space-between;
    }
    .pt_item_child {
        padding-left: 75px;
        padding-right: 25px;
        display: flex;
        justify-content: space-between;
    }
    .pl_item_spliter {
        width: 100%;
        padding-left: 25px;
        padding-right: 25px;
    }
    .pl_item_spliter_line {
        max-width: 500px;
        width: 100%;
        height: 1px;
        background-color: black;
        margin-left: auto;
    }
    span {
        margin-bottom: 3px;
    }
    @media (max-device-width: 1024px), (max-width: 1023px) {
        .contentholder {
            padding: 0px;
            width: 100%;
            max-width: 100vw;
            margin-left: auto;
            margin-right: auto;
        }
        .exportbuttonbar {
            margin-top: 10px;
            width: 100%;
            display: flex;
            flex-direction: column;
        }
        .exportbuttonbar button {
            max-width: 100%;
            width: 100%;
            background-color: #ff9100;
            color: white;
        }
        .righttoolsholder {
            width: 100%;
            display: flex;
            flex-direction: column;
            justify-content: start;
            
        }
        :global(.righttoolsholder .group) {
            margin-left: 0px;
        }
    }
</style>